import { call, put, takeLatest, all } from "redux-saga/effects";
import { message } from "antd";

import {
  FETCH_ORGANISATIONS_SUCCESS,
  FETCH_ORGANISATIONS,
  FETCH_ORGANISATIONS_ERROR,
  UPDATE_ORGANISATION,
  UPDATE_ORGANISATION_SUCCESS,
  UPDATE_ORGANISATION_ERROR,
  CREATE_ORGANISATION,
  CREATE_ORGANISATION_SUCCESS,
  CREATE_ORGANISATION_ERROR,
  SEARCH_ORGANISATION,
  SEARCH_ORGANISATION_SUCCESS,
  SEARCH_ORGANISATION_ERROR,
} from "../../actions/receptionist/organisationsAction";

import {
  fetchOrganisationsAPI,
  updateOrganisationAPI,
} from "../../../services/organisations-service";

function* fetchOrganisations(organisations) {
  try {
    const response = yield call(fetchOrganisationsAPI, organisations.payload);

    if (response.success) {
      yield put({
        type: FETCH_ORGANISATIONS_SUCCESS,
        payload: response.data,
      });
    } else {
      message.error("Failed to fetch Organisations!");

      yield put({ type: FETCH_ORGANISATIONS_ERROR, error: response.error });
    }
  } catch (error) {
    message.error("Failed to fetch Organisations!");

    yield put({ type: FETCH_ORGANISATIONS_ERROR, error });
  }
}

function* searchOrganisation(organisation) {
  try {
    const response = yield call(fetchOrganisationsAPI, organisation.payload);

    if (response.success) {
      yield put({
        type: SEARCH_ORGANISATION_SUCCESS,
        payload: response.data.insuranceOrganisations,
      });
    } else {
      message.error("Failed to search Organisations!");

      yield put({ type: SEARCH_ORGANISATION_ERROR, error: response.error });
    }
  } catch (error) {
    message.error("Failed to search Organisations!");

    yield put({ type: SEARCH_ORGANISATION_ERROR, error });
  }
}

function* updateOrganisation(organisation) {
  try {
    const response = yield call(updateOrganisationAPI, organisation.payload);

    if (response.success) {
      yield put({
        type: UPDATE_ORGANISATION_SUCCESS,
        payload: response.data,
      });
    } else {
      message.error("Failed to update Organisation!");

      yield put({
        type: UPDATE_ORGANISATION_ERROR,
        error: response.error,
      });
    }
  } catch (error) {
    message.error("Failed to update Organisation!");

    yield put({ type: UPDATE_ORGANISATION_ERROR, error });
  }
}

function* createOrganisation(organisation) {
  try {
    const response = yield call(updateOrganisationAPI, organisation.payload);

    if (response.success) {
      yield put({
        type: CREATE_ORGANISATION_SUCCESS,
        payload: response.data,
      });
    } else {
      message.error("Failed to create Organisation!");

      yield put({
        type: CREATE_ORGANISATION_ERROR,
        error: response.error,
      });
    }
  } catch (error) {
    message.error("Failed to create Organisation!");

    yield put({ type: CREATE_ORGANISATION_ERROR, error });
  }
}

function* organisationsWatcher() {
  yield takeLatest(FETCH_ORGANISATIONS, fetchOrganisations);
  yield takeLatest(UPDATE_ORGANISATION, updateOrganisation);
  yield takeLatest(CREATE_ORGANISATION, createOrganisation);
  yield takeLatest(SEARCH_ORGANISATION, searchOrganisation);
}

export default function* rootSaga() {
  yield all([organisationsWatcher()]);
}
